import { Link } from 'react-router-dom'
import { useAdminDestinations, type AdminGroup } from '../lib/adminHome'
import { useHubLang } from '../lib/i18n'
import { ADMIN_HOME, headingLabel, navLabel } from '../lib/hubCopy'

/**
 * SHL-33. The admin home's cards: one per destination the person may open,
 * grouped Support / Administration as the rail groups them.
 *
 * Draws what the shell provides and nothing else — see lib/adminHome.ts for
 * why this must not gate anything itself. `groups` is a prop only for the
 * suite, which renders this without the shell; inside the app it comes from
 * context.
 */
export function AdminHomeCards({ groups: given }: { groups?: AdminGroup[] }) {
  const fromShell = useAdminDestinations()
  const groups = given ?? fromShell
  const lang = useHubLang()
  const t = ADMIN_HOME[lang]

  if (groups.length === 0) return <p className="empty">{t.nothing}</p>

  return (
    <div className="adminhome">
      <p className="adminhome__lede">{t.lede}</p>
      {groups.map((g) => (
        <section key={g.heading} className="adminhome__group" aria-labelledby={`adminhome-${g.heading}`}>
          <h2 id={`adminhome-${g.heading}`} className="adminhome__heading">
            {headingLabel(lang, g.heading)}
          </h2>
          <ul className="adminhome__cards">
            {g.items.map((i) => (
              <li key={i.route}>
                <Link className="adminhome__card" to={`/${i.route}`}>
                  <span className="adminhome__title">
                    {navLabel(lang, i.label)}
                    {i.badge !== undefined && i.badge > 0 && (
                      <span className="navitem__badge" aria-label={t.waiting(i.badge)}>
                        {i.badge > 99 ? '99+' : i.badge}
                      </span>
                    )}
                  </span>
                  {t.about[i.route] && <span className="adminhome__about">{t.about[i.route]}</span>}
                </Link>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  )
}
